import React from 'react';
import DeleteHoldButton from '../common/DeleteHoldButton';

const EvaluationPlanDeleteHoldButton: React.FC<{
  itemId: string;
  disabled?: boolean;
  onRemove: () => void;
  className?: string;
  label?: string;
  confirmTitle?: string;
  confirmDescription?: string;
}> = ({
  itemId,
  disabled = false,
  onRemove,
  className = '',
  label,
  confirmTitle = '삭제할까요?',
  confirmDescription = '삭제하면 되돌릴 수 없습니다.',
}) => {
  return (
    <DeleteHoldButton
      key={itemId}
      disabled={disabled}
      onDelete={onRemove}
      className={`cp-admin-notices-icon-btn cp-evaluation-plan-delete-hold-btn${className ? ` ${className}` : ''}`}
      holdBarClassName="cp-evaluation-plan-delete-hold-bar"
      title="짧게 누르면 확인 후 삭제 · 길게 누르면 바로 삭제"
      ariaLabel={label ? `${label} (짧게: 확인, 길게: 바로 삭제)` : '삭제 (짧게: 확인, 길게: 바로 삭제)'}
      confirmTitle={confirmTitle}
      confirmDescription={confirmDescription}
    >
      {label ? (
        <>
          <svg
            className="cp-evaluation-plan-delete-hold-icon-inline"
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden
          >
            <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
              d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="cp-evaluation-plan-delete-hold-label">{label}</span>
        </>
      ) : (
        <img src="/Trash.svg" alt="" className="cp-admin-notices-tool-icon" width={18} height={18} decoding="async" />
      )}
    </DeleteHoldButton>
  );
};

export default EvaluationPlanDeleteHoldButton;
